import React, { useEffect, useState } from 'react'
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import { InfoAlert } from '../../CommonUtils/SweetAlerts';
import { viewImage } from '../../CommonUtils/viewImage';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup'
import * as bie from "react-bootstrap";
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { FaDownload } from 'react-icons/fa';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';

export default function TotalCollegesStatusReport() {
    const [showTotalClgStatusReport, setTotalClgStatusReport] = useState([]);
    const [universityList, setUniversityList] = useState([])
    const [clgStatusTable, setclgStatusTable] = useState(false)
    const Ubcode = sessionStorage.getItem('ub_code');

    const userid = (sessionStorage.getItem('user_id'))
    const isValidUser = userid && (userid.startsWith('affl') || userid.startsWith('reg'));
    let dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
            acYear: "",
            ubCode: "",
            collType: "",
            logintype: isValidUser,
        },
        validationSchema: Yup.object({
            acYear: Yup.string().required(ERROR_MSG).nullable(),
            ubCode: Yup.string().when('logintype', {
                is: false,
                then: Yup.string().required(ERROR_MSG),
                otherwise: Yup.string().nullable()
            }),

            collType: Yup.string().required(ERROR_MSG).nullable(),
        }),
        onSubmit: (values) => {

            const ubcodecondition = isValidUser == false ? values?.ubCode : Ubcode
            let url = config.url.API_URL + "gettotalstatusreport/" + values?.acYear + "/" + ubcodecondition + "/" + values?.collType;

            CommonAxiosGet(url).then((res) => {
                if (res?.data?.scode === '01') {
                    setTotalClgStatusReport(res?.data?.data)
                    setclgStatusTable(true)
                }
                else if (res?.data?.scode === '02') {
                    InfoAlert("No Data Found")
                }
            })
        }
    })
    const Columns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1 },
        {
            Header: "University Name", accessor: "ub_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.ub_name}</div>
            ),
        },
        {
            Header: "College Code", accessor: "coll_code",
        },
        {
            Header: "College Name", accessor: "inst_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.inst_name}</div>
            ),
        },
        {
            Header: "College Application", accessor: "",
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn text-center"
                        onClick={() => {
                            GetClgSubmissionPdf(row?.original?.coll_code)
                        }}>
                        <FaDownload size={20} />
                    </button>
                )
            }
        },
        {
            Header: "FFCA Status",
            accessor: '',
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn text-center"
                        onClick={() => {
                            GetFfcaSubmissionPdf(row?.original?.coll_code)
                        }}>
                        <FaDownload size={20} />
                    </button>
                )
            }

        },
        {
            Header: "CDC Dean Approval", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    {row?.original?.cdc_file_path === "-" ? ("-") : (
                        <button type="button" className="btn text-center" onClick={() => viewImage(row?.original?.cdc_file_path)} >
                            <FaDownload size={20} /> </button>
                    )}
                </>
                );
            }

        },
        {
            Header: "Affiliation Order Generated", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    {row?.original?.final_pdf_path === "-" ? ("-") : (
                        <button type="button" className="btn text-center"
                            onClick={() => {
                                viewImage(row?.original?.final_pdf_path)
                            }}>
                            <FaDownload size={20} />
                        </button>)}</>
                )
            }
        },

    ]


    function GetClgSubmissionPdf(collCode) {
        let url;

        if (formik.values.collType === "oamdc") {
            url = `${config.url.API_URL}getdegreepdf/${collCode}/${formik?.values?.acYear}`;
        } else {
            url = `${config.url.API_URL}getAffiliationPdf/${collCode}/${formik?.values?.acYear}`;
        }

        CommonAxiosPost(url, dispatch).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            }
            else {
                console.log(res);
            }
        })
    }

    function GetFfcaSubmissionPdf(collcode) {
        let url = config.url.API_URL + `getFfcaPdf/` + collcode + "/" + formik?.values?.acYear;
        CommonAxiosPost(url).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            } else {
                console.log("No Data Found")

            }
        })
    }
    function GetUniversityListDetails() {
        let url = config.url.API_URL + `getuniversitydata`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setUniversityList(res?.data?.data)
            }
            else {
                setUniversityList([])
            }
        })
    }
    useEffect(() => {
        GetUniversityListDetails();
    }, [])
    return (
        <div>
            <bie.Container fluid className="px-1" >
                <FormikProvider value={formik}>
                    <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form" >
                        <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100">
                            {clgStatusTable === false ?
                                <>
                                    <div className="inner-herbpage-service-title-sub pt-0"  > <h1>Total Status Report</h1> </div>
                                    <bie.Row className="my-3 px-3">
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                            <label classname='mb-1' className="label-text-style"><b className='mt-2' style={{ color: 'red' }}>* </b>Academic Year</label>
                                            <Field as="select" name="acYear" className="form-control mb-2" onChange={(e) => {
                                                formik?.setFieldValue("ubCode", "");
                                                formik?.setFieldValue("collType", "")
                                                setTotalClgStatusReport([])
                                            }}>
                                                <option value=''>--select--</option>
                                                <option value="2025-26">2025-26</option>
                                                <option value="2024-25">2024-25</option>
                                                <option value="2023-24">2023-24</option>

                                            </Field>
                                            <ErrorMessage name="acYear" component="div" className="text-error" />
                                        </bie.Col>
                                        {isValidUser == false && (<>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                                <label classname='mb-1' className="label-text-style">
                                                    <b className='mt-2' style={{ color: 'red' }}>* </b>University</label>
                                                <Field as="select" name="ubCode" className="form-control mb-2" onChange={(e) => {
                                                    formik?.setFieldValue("collType", ""); setTotalClgStatusReport([])
                                                }} >
                                                    <option value=''>--select--</option>
                                                    <option value="999">All</option>
                                                    {universityList && universityList?.map((rel, i) => (
                                                        <option value={rel?.ub_code}>{rel?.ub_name}</option>
                                                    ))}
                                                </Field>
                                                <ErrorMessage name="ubCode" component="div" className="text-error" />
                                            </bie.Col>
                                        </>)}
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                            <label classname='mb-1' className="label-text-style">
                                                <b className='mt-2' style={{ color: 'red' }}>* </b>Category</label>
                                            <Field as="select" name="collType" className="form-control mb-2"
                                                onChange={(e) => { setTotalClgStatusReport([]) }} >
                                                <option value=''>--select--</option>
                                                <option value="OAMDC">OAMDC</option>
                                                <option value="NON-OAMDC">NON-OAMDC</option>

                                            </Field>
                                            <ErrorMessage name="collType" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='pt-4'>
                                            <button type='submit' className="btn btn-primary " >Get Report</button> </bie.Col>
                                    </bie.Row>
                                </> :
                                <bie.Row className="my-3 px-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                                        <div className="inner-herbpage-service-title-sub pt-0" > <h1>Total Status Report - {formik?.values?.collType} -{formik?.values?.acYear}</h1> </div>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                                        <button type='button' className="btn btn-primary btn-sm" onClick={() => { setclgStatusTable(false) }} >Back</button>
                                    </bie.Col>
                                    <div className="table-responsive">
                                        <CommonReactTable data={showTotalClgStatusReport} columns={Columns} filename="Total Status Report"
                                            headerName={`Total Status Report`} />
                                    </div>
                                </bie.Row>}
                        </bie.Container>
                    </Form>
                </FormikProvider>
            </bie.Container>
        </div>
    )
}
